<template>
  <div>
    <drop @drop="handleDrop">
      <div v-if="uploadInProgress" class="drop-zone">
        <v-progress-circular color="primary" indeterminate :size="75" />
      </div>

      <div v-else-if="!value" class="drop-zone drop-zone--clickable" @click.stop.prevent="openFSPicker">
        <v-icon color="primary" class="upload-icon">file_upload</v-icon>
        <span class="upload-title">{{ adminText(&quot;shellAll.upload_venue_map&quot;, &quot;Upload Venue Map&quot;) }}</span>
        <span class="upload-description">{{ adminText(&quot;shellAll.jpg_png_svg_formats_with_the_size_of_up_to&quot;, &quot;JPG, PNG, SVG formats with the size of up to&quot;) }} {{ maxFileSizeMb }} {{ adminText(&quot;shellAll.mb&quot;, &quot;MB.&quot;) }}</span>
      </div>

      <div v-else class="drop-zone drop-zone--filled">
        <img :src="value" class="venue-map" :alt="adminText(&quot;shellAll.venue_map&quot;, &quot;Venue map&quot;)">
        <v-layout class="venue-map-actions" justify-center>
          <v-flex shrink class="pr-2">
            <v-btn icon class="size-32 m-0 primary" @click.stop="openFSPicker">
              <v-icon>photo_library</v-icon>
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn icon class="size-32 m-0 error" @click.stop="removeVenueMap">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </drop>

    <hidden-file-input
      ref="file-input"
      accept="image/png,image/jpeg,image/svg+xml,.png,.jpg,.jpeg,.svg"
      :max-file-size-mb="maxFileSizeMb"
      @file="uploadVenueMap($event)"
    />
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import HiddenFileInput from './../hidden-file-input'
import { getUploadOptions, uploadImage } from '@/utils'
import { UploadPaths } from '@/types'

export default {
  mixins: [AdminContext],
  name: 'venue-map-field',
  components: {
    HiddenFileInput,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    maxFileSizeMb: {
      type: String,
      default: '10',
    },
  },
  data() {
    return {
      uploadInProgress: false,
    }
  },
  methods: {
    handleDrop(data, event) {
      event.preventDefault()
      const {
        dataTransfer: { files },
      } = event
      if (files && files[0]) this.uploadVenueMap(files[0])
    },
    removeVenueMap() {
      this.$emit('input', null)
    },
    async uploadVenueMap(file) {
      this.uploadInProgress = true
      try {
        // Venue maps (SVG included) are uploaded as-is - resizing would rasterise them.
        const { file: upload, path } = await getUploadOptions(file, UploadPaths.UNGROUPED, {
          resize: false,
        })
        const url = await uploadImage(upload, path)
        this.$emit('input', url)
      } finally {
        this.uploadInProgress = false
      }
    },
  },
}
</script>

<style scoped>
.drop-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 484px;
  padding: 32px 24px;
  border: 1px dashed #d9d9d9;
  border-radius: 24px;
  background-color: #f5f5f5;
}

.drop-zone--clickable {
  cursor: pointer;
}

.drop-zone--clickable:hover {
  background-color: rgba(2, 119, 189, 0.08);
}

.drop-zone--filled {
  position: relative;
  padding: 24px;
}

.upload-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.upload-title {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: -0.24px;
  text-align: center;
  color: #0277bd;
  margin-bottom: 8px;
}

.upload-description {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  color: #979797;
}

.venue-map {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.venue-map-actions {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
}

.size-32 {
  width: 32px;
  height: 32px;
}

.venue-map-actions >>> .v-icon {
  font-size: 20px;
}
</style>
